import { Grid, Typography } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as TransactionSaved } from '../media/transaction-saved.svg';
import { styles } from './save-transaction-styles';

const SaveTransaction: React.FC = (): JSX.Element => {
  const classes = styles();
  const { t } = useTranslation();

  return (
    <Grid
      container
      direction='column'
      className={`fullHeight ${classes.saveTransactionConfirmationContainer}`}
      data-testid={`save-transaction`}
    >
      <Grid item>
        <Typography className={classes.typography} data-testid='save-transaction-message'>
          {t('Transaction_Saved')}
        </Typography>
      </Grid>
      <Grid item>
        <Grid container justifyContent='center'>
          <Grid item xs={3}>
            <TransactionSaved className={classes.icon} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SaveTransaction;
